import script from "./Notifications.vue?vue&type=script&lang=ts&setup=true"
export * from "./Notifications.vue?vue&type=script&lang=ts&setup=true"

import "./Notifications.vue?vue&type=style&index=0&id=61938ea0&scoped=true&lang=css"

import exportComponent from "/Users/lyon/Desktop/Work s2j/app-rentalcar-project/admin-v3 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61938ea0"]])

export default __exports__